/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import * as weSaluteActions from './WeSalute-Actions';
import weSaluteReducer from './WeSalute-Reducer';

export { weSaluteActions };
export default weSaluteReducer;
